import { formatDate } from '@amelio/ui-library';

import { parseIsoDate } from '@/utils/dateUtils';

/**
 * Two calendar days as the one phrase that spans them, the year said once: `'janv. 1 - juin 30,
 * 2026'`. Both bounds are read as local days rather than by `new Date`, which would land on the day
 * before anywhere west of Greenwich and slide a period's last day out of it.
 *
 * Its own module rather than `dateUtils`, which every other date helper lives in: this one is the
 * only one that needs the library to spell a month, and `dateUtils` is imported from inside test
 * factories that stand in for that very library. A helper it pulls the library into makes those
 * factories wait on themselves.
 */
export const formatDayRange = (startDay: string, endDay: string, language: string): string => {
    const start = formatDate({ date: startDay, format: 'MMM D', language });
    const end = formatDate({ date: endDay, format: 'MMM D', language });

    return `${start} - ${end}, ${parseIsoDate(startDay)?.getFullYear()}`;
};
